export enum Constants {
    DOCUMENT_PREVIEW_INITIATE = 'DOCUMENT_PREVIEW_INITIATE',
    DOCUMENT_PREVIEW_HIDE = 'DOCUMENT_PREVIEW_HIDE',
    DOCUMENT_PREVIEW_CLEAR = 'DOCUMENT_PREVIEW_CLEAR',
    ARTIFACT_PREVIEW = 'ARTIFACT_PREVIEW',
    MESSAGE_LOADING = 'MESSAGE_LOADING',
    PREVIEW_DOCUMENT_UPDATE = 'PREVIEW_DOCUMENT_UPDATE',
}
